// WorkspaceProjectSwitcher — shows the current workspace project and lets the
// user switch between workspace projects (activity trackers).
// Progressive disclosure: hidden when the user has only one workspace project.
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.

export const WorkspaceProjectSwitcherItem = {
  extends: 'Button',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  padding: 'Z1 A',
  round: 'Z',
  cursor: 'pointer',
  theme: 'tertiary',
  width: '100%',

  Icon: { name: 'check', boxSize: 'A A' },
  Name: {
    tag: 'span',
    fontSize: 'Z2',
    text: (el, s) => s.name || s.title || ''
  },

  onClick: (e, el, s) => {
    e.preventDefault()
    let dropdown = el.parent
    while (dropdown && !dropdown.WorkspaceProjectSwitcherDropdown) dropdown = dropdown.parent
    if (dropdown?.WorkspaceProjectSwitcherDropdown) {
      dropdown.WorkspaceProjectSwitcherDropdown.update?.({
        style: { opacity: '0', visibility: 'hidden', pointerEvents: 'none' }
      })
    }
    el.call('switchWorkspaceProject', s.root, el.context?.sdk, el.context?.queryClient, s.id)
    localStorage.setItem('activeWorkspaceProject', s.id)
  }
}

export const WorkspaceProjectSwitcherDropdown = {
  position: 'absolute',
  top: '100%',
  left: '0',
  zIndex: '100',
  minWidth: 'G',
  padding: 'Z',
  round: 'A',
  theme: 'dialog',
  boxShadow: '0 A Z -Z black.2',
  opacity: '0',
  visibility: 'hidden',
  pointerEvents: 'none',

  childExtends: 'WorkspaceProjectSwitcherItem',
  childrenAs: 'state',
  children: (el, s) => s.root?.workspaceProjects || []
}

export const WorkspaceProjectSwitcher = {
  position: 'relative',
  // Progressive disclosure — hide when only one workspace project
  hide: (el, s) => !s.root?.workspaceProjects || s.root.workspaceProjects.length <= 1,

  Trigger: {
    extends: 'Button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',

    Icon: { name: 'check', boxSize: 'A A' },
    Name: {
      tag: 'span',
      fontSize: 'Z2',
      text: (el, s) => s.root?.workspaceProject?.name || 'Select project'
    },
    ChevronIcon: { name: 'chevronDown', boxSize: 'A A' },

    onClick: (e, el) => {
      e.stopPropagation()
      const switcher = el.parent
      const dropdown = switcher?.WorkspaceProjectSwitcherDropdown
      if (!dropdown) return
      const next = !dropdown.forcedVisible
      dropdown.forcedVisible = next
      dropdown.update?.({
        style: {
          opacity: next ? '1' : '0',
          visibility: next ? 'visible' : 'hidden',
          pointerEvents: next ? 'auto' : 'none'
        }
      })
    }
  },

  WorkspaceProjectSwitcherDropdown: {}
}
